import SearchToolBarForItemSearch from '../SearchToolBar/SearchToolBarForItemSearch'
import SearchResultDataTable from '../SearchResultDataTable/SearchResultDataTable'
import SearchResultCardGrid from '../SearchResultCardGrid'
import ItemSearchModal from '../AddItemToListModal/AddItemToListModal'
import {SearchPagination} from '../../../searchPagination/SearchPagination'
import {FullSearchResult} from '../../useFullSearch'

export const SearchResultTableForClassificationAndPhrase = ({
    fullSearchResult
}: {
    fullSearchResult: FullSearchResult
}) => {
    const {
        searchResult,
        searchFilters,
        search,
        searchResultControl: {
            legacyView,
            addToMultiSelect,
            removeFromMultiSelect,
            handleAddSingleItemToList,
            isSelected,
            pageSize,
            addItemsToListModalVisible,
            setAddItemsToListModalVisible,
            selectedItemIds,
            handleRowSelectionChange
        },
        page,
        handlePageChange,
        isSearchFetching,
        fullSearchParams
    } = fullSearchResult

    const itemIds = Array.from(selectedItemIds).map(id => String(id))

    return <div>
        <div className="search-results-table">
            <SearchToolBarForItemSearch fullSearchResult={fullSearchResult}/>
            {
                !legacyView &&
                <SearchResultDataTable
                    definitionsToDisplay={searchResult?.definitionsToDisplay ?? []}
                    list={searchResult?.elements ?? []}
                    handleAddSingleItemToList={handleAddSingleItemToList}
                    highlightPhrase={search?.phrase?.phraseDetail ?? ''}
                    selectedItems={selectedItemIds}
                    handleRowSelectionChange={handleRowSelectionChange}
                    enableColumFiltering={true}
                    isLoading={isSearchFetching}
                    showAddToListButton = {false}
                    fullSearchParams={fullSearchParams}
                    filterValues={searchFilters}
                />
            }
            {
                legacyView &&
                <SearchResultCardGrid
                    searchItems={searchResult?.elements ?? []}
                    addToMultiSelect={(item) => addToMultiSelect([item])}
                    removeFromMultiSelect={removeFromMultiSelect}
                    handleAddSingleItemToList={handleAddSingleItemToList}
                    isSelected={isSelected}
                    highlightPhrase={search?.phrase?.phraseDetail ?? ''}
                    isMultiSelectionEnabled={true}
                />
            }
        </div>
        <SearchPagination totalElements={searchResult?.totalElements || 0}
                          pageSize={pageSize}
                          page={page}
                          handlePageChange={handlePageChange}/>
        {addItemsToListModalVisible &&
            <ItemSearchModal closeModal={() => setAddItemsToListModalVisible(false)}
                             itemIds={itemIds}/>}
    </div>
}
